import { Facet as HeadlessFacet } from "@coveo/headless";
import { useEffect, useState } from "react";

interface FacetProps {
	controller: HeadlessFacet;
	title: string;
	index: number;
}

const SearchPageFilter = ({ controller, index, title }: FacetProps) => {
	const [state, setState] = useState(controller.state);
	const [show, setShow] = useState(false);

	useEffect(
		() =>
			controller.subscribe(() => {
				setState(controller.state);
			}),
		[controller]
	);

	useEffect(() => {
		if (index === 0) {
			setShow(true);
		}
	}, [index]);

	if (!state.values.length) {
		return null;
	}

	return (
		<div className="search-page-facet">
			<div
				className="search-page-facet-header"
				role="button"
				tabIndex={0}
				onKeyDown={() => setShow((prevShow) => !prevShow)}
				onClick={() => setShow((prevShow) => !prevShow)}
			>
				<div className="search-page-facet-title">{title}</div>
				<div className={`search-page-facet-arrow-${show ? "down" : "up"}`}></div>
			</div>
			<ul className={`search-page-facet-values ${show ? "show" : ""}`}>
				{state.values.map((value) => (
					<li className="search-page-facet-value" key={value.value}>
						<label className="search-page-facet-value-label">
							<div className="search-page-facet-value-label-wrapper">
								<input
									name="facet"
									type="checkbox"
									checked={controller.isValueSelected(value)}
									onChange={() => {
										controller.toggleSelect(value);
									}}
									disabled={state.isLoading}
									aria-label={value.value}
									data-a="true"
									data-a-lbl={value.value}
									data-a-cat="Coveo"
									data-a-act={"Filter"}
								/>
								<div
									role="button"
									tabIndex={0}
									className={`search-page-facet-value-label-checkbox ${
										controller.isValueSelected(value) ? "selected" : ""
									}`}
								></div>
								<span className="search-page-facet-value-label-caption">
									{value.value}
									<span className="search-page-facet-value-label-count">
										{state.values.find((f) => f.state === "selected") !== undefined
											? controller.isValueSelected(value)
												? value.numberOfResults
												: `+${value.numberOfResults}`
											: value.numberOfResults}
									</span>
								</span>
							</div>
						</label>
					</li>
				))}
			</ul>
		</div>
	);
};

export default SearchPageFilter;
